import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import _ from 'lodash'
import moment from 'moment'
import Title from '../general/title'
import { Link } from 'react-router-dom'
import getData from 'helpers/submitData'
import { loadingStatus } from 'actions'
import helpers from "helpers/helpers"
import FullTable from "components/FullTable"

class BrokerageExceptions extends Component {

	constructor(props) {
		super(props)
		this.state = {
			rows: [],
			filtered: [],
			sorted: []
		}
	}

	componentDidMount() {
		this.props.loadingStatus(false)
		getData("getBrokerageExceptions", {dates: this.props.currentDates, properties: this.props.activeProperties}).then((resp) => {
			this.setState({rows:resp.data})
		}).catch(e => {
			console.log(e)
		})
	}

	componentDidUpdate(prevProps) {
		if(prevProps.activeProperties !== this.props.activeProperties) {
			getData("getBrokerageExceptions", {
				dates: this.props.currentDates,
				properties: this.props.activeProperties,
			})
				.then((resp) => {
					this.setState({ rows: resp.data })
					this.props.loadingStatus(false)
				})
				.catch((e) => {
					console.log(e)
				})
		}
	}

	countActions = (id) => {
		var count = 0
		this.props.payload.activity.forEach((r) => {
			if(id == r.user) {
				count++
			}
		})

		return count
	}

	buildTable = () => {
		let ret = []

		_.forEach(this.state.rows, v => {
			let addedDate = moment.unix(v.addedDate).format('MM/DD/YY LT')
			let sale = _.find(this.props.payload.sales.current, {id: v.sale_id})
			let salesperson = _.find(this.props.payload.public.salespeople, { id: v.salesperson })
			ret.push({
				sale: sale ? sale.address : '',
				salesperson: salesperson ? `${salesperson.first} ${salesperson.last}` : '',
				license: v.license,
				type: v.type,
				addedDate,
			})
		})

		return ret
	}

	createTable = () => {
		const columns = [
			{
				Header: "Type",
				accessor: "type",
				Cell: (v) => _.capitalize(v.value),
				filterMethod: (f, r) => helpers.tableText(f, r, "type"),
			},
			{
				Header: "Sale",
				accessor: "sale",
				filterMethod: (f, r) => helpers.tableText(f, r, "sale"),
			},
			{
				Header: "Salesperson",
				accessor: "salesperson",
				filterMethod: (f, r) => helpers.tableText(f, r, "salesperson"),
			},
			{
				Header: "License",
				accessor: "license",
				filterMethod: (f, r) => helpers.tableText(f, r, "license"),
			},
			{
				Header: "Date",
				accessor: "addedDate",
			},
		]
		return (
			<div className="content">
				<FullTable
					data={this.buildTable()}
					columns={columns}
					name="brokerageExceptions"
					title="Brokerages"
					classNames={["small"]}
				/>
			</div>
		)
	}

	render() {

		return (
			<div className="sales">
				<div className="imageGroup">
					<Title title="Brokerage Exceptions Log" />
					{this.createTable()}
				</div>
			</div>
		)
	}

}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
        compareDates: state.compareDates,
		payload: state.payload,
		activeProperties: state.activeProperties
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({
		loadingStatus
	}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(BrokerageExceptions)